import RouterBase from '../../../components/navigation/RouterBase'
import LinkedResources from './LinkedResources'
import { URLAPP } from '../../../config'
import DisplayGroups from '../../../components/navigation/DisplayGroups'

export default function ResourcesRouter() {
    return (
        <RouterBase
            items={[
                {
                    component: <DisplayGroups />,
                    path: "grupo/:grupo",
                    fullPath: URLAPP.linkedResourcesGroup
                },
                { component: <LinkedResources />, fullPath: URLAPP.linkedResources, path: '/:labelmenu' },
            ]}
        />
    )
}